import * as React from 'react';
import { withTranslation } from 'react-i18next';

import { InterestService } from '../../../services/InterestService';
import { Autocomplete } from '../../autocomplete';
import { TagsBox } from '../../tags';
import { message } from '../../../../ui';

export class Renderer extends React.Component {
  itemToString = (item) => (item === null ? '' : item.name);

  state = {
    data: [],
    isLoaded: false,
  };

  getDataForValue = async (search) => {
    let data = this.state.data;

    if (!this.state.isLoaded) {
      const response = await InterestService.get();

      if (response.ok) {
        this.setState({ data: response.data, isLoaded: true });
        data = response.data;
      } else {
        message.error('Failed to load data.');
      }
    }

    const regex = new RegExp(search ? search : '', 'gi');
    return data.filter((interest) => interest.name.match(regex));
  };

  appendToSelection = (item) => {
    if (item !== null) {
      this.props.onChange(this.props.selection.concat(item));
    }
  };

  render() {
    return (
      <Autocomplete
        clearOnSelect
        dataForValue={this.getDataForValue}
        currentSelectedData={this.props.currentSelectedData}
        itemToString={this.itemToString}
        getRowId={(item) => item.id}
        onSelect={this.appendToSelection}
        placeholder={this.props.placeholder}
        renderInput={(ref, inputProps) => (
          <div ref={ref}>
            <TagsBox
              maxCount={this.props.maxCount}
              inputProps={inputProps}
              placeholder={this.props.t('Search...')}
              selection={this.props.selection}
              itemToString={this.itemToString}
              onChange={this.props.onChange}
              data-test-id="search_interests"
            />
          </div>
        )}
      />
    );
  }
}

export const InterestsInput = withTranslation()(Renderer);
